import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, renderSlot as _renderSlot, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "list__header-title" }
const _hoisted_3 = {
  key: 0,
  class: "list__header-amount"
}
const _hoisted_4 = {
  key: 1,
  class: "list__items"
}

import { PropType, toRefs, ref, computed } from 'vue'
import ListRow from '@/design-system/atoms/ListRow.vue'
import TooltipStandard from '../atoms/TooltipStandard.vue'
import LayoutSearchState from './LayoutSearchState.vue'
import { useStore } from 'vuex'

interface EMITS {
  (e: 'select', item: Object): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ListStandard',
  props: {
  title: {
    type: String,
    default: ''
  },
  icon: {
    type: Object,
    required: false,
    default: () => undefined
  },
  items: {
    type: Array as PropType<Array<any>>,
    default: () => []
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  hasTooltips: {
    type: Boolean,
    default: false
  },
  searchString: {
    type: String,
    default: ''
  }
},
  emits: ["select"],
  setup(__props, { emit: __emit }) {

const props = __props
const { items, isLoading, searchString } = toRefs(props)
const emits = __emit
const showTooltip = ref(false)
const trackedMouseEvent = ref<Object>()
const hoveredTitle = ref<String>('')
const store = useStore()
const mobileScreen = computed<boolean>(() => store.state.mobileScreen)

function onSelect(item: Object, event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('select', item)
}

function trackPointer(event, header?: string, subheader?: string) {
  const rect = event.currentTarget.getBoundingClientRect()
  if (event) {
    trackedMouseEvent.value = {
      x: rect.x + rect.width / 2,
      y: rect.bottom - 45
    }
    const targetEl = event.target as HTMLElement
    targetEl.addEventListener('mouseleave', () => (showTooltip.value = false))

    if (header) {
      hoveredTitle.value = header
      if (subheader) hoveredTitle.value += '\n\n (' + subheader + ')'
    } else if (!header && subheader) hoveredTitle.value = subheader
    showTooltip.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["list__header", { 'list__header-w-icon': __props.icon }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon))),
            _createTextVNode(" " + _toDisplayString(__props.title), 1)
          ]),
          (__props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "(" + _toDisplayString(_unref(isLoading) ? '-' : _unref(items).length) + ")", 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(items).length && !_unref(isLoading))
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
            return (_openBlock(), _createBlock(ListRow, {
              key: item.id,
              header: item.header,
              subheader: item.subheader,
              icon: item.icon,
              imgSource: item.imgSource,
              hasTooltip: __props.hasTooltips,
              tabindex: "0",
              onClick: ($event: any) => (onSelect(item)),
              onKeydown: [
                _withKeys(($event: any) => (onSelect(item)), ["enter"]),
                _withKeys((event) => onSelect(item, event, true), ["space"])
              ],
              onLongItemText: trackPointer
            }, null, 8, ["header", "subheader", "icon", "imgSource", "hasTooltip", "onClick", "onKeydown"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_unref(items).length && !_unref(isLoading) && mobileScreen.value)
      ? (_openBlock(), _createBlock(LayoutSearchState, {
          key: 2,
          empty: true,
          searchString: _unref(searchString)
        }, null, 8, ["searchString"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    _withDirectives(_createVNode(TooltipStandard, {
      arrowPosition: "top-center",
      positionAbsoulute: true,
      class: "tooltip",
      pointerEvent: trackedMouseEvent.value,
      text: hoveredTitle.value.toString()
    }, null, 8, ["pointerEvent", "text"]), [
      [_vShow, showTooltip.value]
    ])
  ]))
}
}

})